import { call, put, select } from "redux-saga/effects";
import { selectElements as selectElementsAda } from "@bitComponents/adabyron/cqv2";
import { WEB_SERVICES } from "./webServices";
import { 
  CQ_ACTION_CODES,
  TEXT_TYPES_CODES,
 } from "../catalogConstants";
import { containsNumber, getProductOfferingTextByType } from "../utils/general";
import {
  PRODUCT_TYPES,
  getProductTypeByProductOfferingTypes,
} from "../utils/catalog";
import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda";

const contextStore = (state) => state.context.data;

/**
 * Calcula la intersección entre un array de objetos y un array simple
 * basándose en la propiedad 'poId' del primer array y los valores del segundo array.
 * @param {Array<Object>} arrayOfObjects - El array de objetos con propiedades 'label' y 'poID' y 'value'.
 * @param {Array<number>} simpleArray - El array simple con valores a comparar.
 * @returns {Array<Object>} - Un array de objetos que representan la intersección.
 */
const calculateIntersection = (arrayOfObjects, simpleArray) => {
  // Filter objects whose 'po' property is present in the simpleArray
  return arrayOfObjects.filter((object) => simpleArray.includes(object.poId));
};

const filterAlreadyOwnedProductsChoices = (
  alreadyOwnedProductsChoices,
  productOfferingsArray
) => {
  const newAlreadyOwnedProductsChoices = [];
  alreadyOwnedProductsChoices.forEach((alreadyOwnedProductChoices) => {
    const newAlreadyOwnedProductChoices = JSON.parse(
      JSON.stringify(alreadyOwnedProductChoices)
    );
    const migrationOptions = alreadyOwnedProductChoices.options.find(
      (option) => option.actionId === CQ_ACTION_CODES.MIGRATION
    );
    const migrationOptionsIndex =
      alreadyOwnedProductChoices.options.indexOf(migrationOptions);

    const migrationOptionsFiltered = calculateIntersection(
      migrationOptions.destinationProducts,
      productOfferingsArray
    );

    if (migrationOptionsFiltered && migrationOptionsFiltered.length > 0) {
      newAlreadyOwnedProductChoices.options[
        migrationOptionsIndex
      ].destinationProducts = migrationOptionsFiltered;
    }

    newAlreadyOwnedProductsChoices.push(newAlreadyOwnedProductChoices);
  });

  return newAlreadyOwnedProductsChoices;
};

const normalizeSelectElements = (
  response,
  productOfferingsArray,
  netflixObj
) => {
  const { customerQuoteItems } = response;

  if (customerQuoteItems) {
    if (customerQuoteItems.length > 1) {
      const frontSonda = new FrontSonda({
        processName: "normalizeSelectElements",
        filePath: "bitSagas/selectElements",
      });
      frontSonda.severalMessage({
        info: `Se han recibido más customerQuoteItems de los esperados`,
      });
      return null;
    }
  }

  const alreadyOwnedProductsChoices = [];
  const autoSelectedAlreadyOwnedProductsChoices = [];
  let mustAskClient = false;
  let areLMAChoices = false;

  if (
    customerQuoteItems &&
    Array.isArray(customerQuoteItems) &&
    customerQuoteItems[0] &&
    customerQuoteItems[0].choices &&
    Array.isArray(customerQuoteItems[0].choices)
  ) {
    customerQuoteItems[0].choices.forEach((choice) => {
      const {
        customerQuotePossibleActions: electionGroups,
        productOfferingTypes,
      } = choice;
      const productType =
        getProductTypeByProductOfferingTypes(productOfferingTypes);
      electionGroups.forEach((electionGroup) => {
        const {
          customerQuoteItems: secondaryCustomerQuoteItems,
          id,
        } = electionGroup;

        const electionObj = {
          phoneNumber: null,
          id,
          options: [],
          productType,
        };

        const migrationOption = {
          actionId: null,
          destinationProducts: [],
        };

        const unsubscribeOption = {
          actionId: null,
          id: null,
        };

        secondaryCustomerQuoteItems.forEach((customerQuoteItem) => {
          const {
            actionId,
            clientPhoneNumberToBeAppliedTo,
            productOffering,
            id: customerQuoteItemId,
          } = customerQuoteItem;

          if (!electionObj.phoneNumber) {
            electionObj.phoneNumber = clientPhoneNumberToBeAppliedTo;
          } else if (
            electionObj.phoneNumber !== clientPhoneNumberToBeAppliedTo
          ) {
            const frontSonda = new FrontSonda({
              processName: "normalizeSelectElements",
              filePath: "bitSagas/selectElements",
            });
            frontSonda.severalMessage({
              info: `Se ha recibido un phoneNumber diferente al esperado`,
            });
          }

          if (actionId === CQ_ACTION_CODES.MIGRATION) {
            let productNameNPrice = getProductOfferingTextByType(
              productOffering,
              TEXT_TYPES_CODES.ORDINARY
            );

            const price = getProductOfferingTextByType(
              productOffering,
              TEXT_TYPES_CODES.SHORT
            );

            if (containsNumber(price)) {
              productNameNPrice = `${productNameNPrice} - ${price}`;
            }

            migrationOption.destinationProducts.push({
              label: productNameNPrice,
              value: customerQuoteItemId,
              poId: productOffering.id,
            });

            migrationOption.actionId = actionId;
          } else if (actionId === CQ_ACTION_CODES.UNSUBSCRIBE) {
            if (unsubscribeOption.actionId) {
              const frontSonda = new FrontSonda({
                processName: "normalizeSelectElements",
                filePath: "bitSagas/selectElements",
              });
              frontSonda.severalMessage({
                info: `Se han recibido más opciones de baja de las esperadas`,
              });
            } else {
              unsubscribeOption.actionId = actionId;
              unsubscribeOption.id = customerQuoteItemId;
            }
          } else if (actionId === CQ_ACTION_CODES.CONFIGURATION_CHANGE) {
            electionObj.options.push({ actionId, id: customerQuoteItemId });
          }
        });
        if (migrationOption.actionId) {
          electionObj.options.push(migrationOption);
        }

        if (unsubscribeOption.actionId) {
          electionObj.options.push(unsubscribeOption);
        }
        if (productType === PRODUCT_TYPES.MOBILE
          || productType === PRODUCT_TYPES.ADDITIONAL_MOBILE
          || productType === PRODUCT_TYPES.PREPAID
          || productType === PRODUCT_TYPES.MULTI_SIM
        ) {
          alreadyOwnedProductsChoices.push(electionObj);
          mustAskClient = true;
          areLMAChoices = true;
        } else if(productType === PRODUCT_TYPES.NETFLIX) {
          if (netflixObj) {
            const configurationChangeOption = electionObj.options.find(
              (option) =>
                option.actionId === CQ_ACTION_CODES.CONFIGURATION_CHANGE
            );
            const chosenAction = {
              id: electionObj.id,
              customerQuoteItems: [
                {
                  id: configurationChangeOption.id,
                },
              ],
            };
            autoSelectedAlreadyOwnedProductsChoices.push(chosenAction);
          } else {
            const unsubscribeOption = electionObj.options.find(
              (option) => option.actionId === CQ_ACTION_CODES.UNSUBSCRIBE
            );
            const chosenAction = {
              id: electionObj.id,
              customerQuoteItems: [
                {
                  id: unsubscribeOption.id,
                },
              ],
            };
            autoSelectedAlreadyOwnedProductsChoices.push(chosenAction);
          }
        }
      });
    });
  }

  let alreadyOwnedProductsChoicesFiltered = alreadyOwnedProductsChoices;

  if (
    productOfferingsArray &&
    productOfferingsArray.length > 0 &&
    alreadyOwnedProductsChoices.length === productOfferingsArray.length
  ) {
    alreadyOwnedProductsChoicesFiltered = filterAlreadyOwnedProductsChoices(
      alreadyOwnedProductsChoices,
      productOfferingsArray
    );
    areLMAChoices = false;
  }

  return {
    alreadyOwnedProductsChoices: alreadyOwnedProductsChoicesFiltered,
    autoSelectedAlreadyOwnedProductsChoices,
    areLMAChoices,
    mustAskClient,
  };
};

export function* selectElements(params) {
  const {
    cqId,
    chosenActionsArray,
    cqsiId,
    phoneNumber,
    reduxUpdate,
    normalizeHttpErrors,
    productOfferingsArray,
    netflixObj,
  } = params;

  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const args = {
      cqId,
    };
    if (Array.isArray(chosenActionsArray)) {
      args.chosenActionsArray = chosenActionsArray;
    }
    if (cqsiId) {
      args.cqsiId = cqsiId;
    }
    if (phoneNumber) {
      args.clientPhoneNumberToBeAppliedTo = phoneNumber;
    }
    const response = yield call(selectElementsAda, args, context);

    const normalizedResponse = normalizeSelectElements(
      response,
      productOfferingsArray,
      netflixObj
    );
    if (successUpdate) {
      yield put(successUpdate(normalizedResponse));
    }

    return normalizedResponse;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.SELECT_ELEMENTS,
      error
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
